import { Alert } from '@designsforhealth/dfh-react-components'
import React, { FC } from 'react'

import useSiteSettings from '../../../../../../hooks/useSiteSettings'
import {
  DocumentOnFileNotReceived,
  RequiredForCommissionsKey,
} from '../../../../../../lib/practitioner-settings/utils'
import { langCodes } from '../../../../../../utils/siteSettings'
import Spacer from '../../../../../Spacer'
import StatusAndSubmitDoc from '../../../settings/practitioner/StatusAndSubmitDoc'
import { MissingAccountInformationMessage } from './MissingAccountInformationMessage'

// Note: StatusAndSubmitDoc is legacy code likely to be removed in a future Account Documents updates
export const EarnCommissionsNotification: FC<{
  docsForCommissionsNeeded: Array<[RequiredForCommissionsKey, DocumentOnFileNotReceived]>
}> = ({ docsForCommissionsNeeded }) => {
  const { lang } = useSiteSettings() || {}
  return lang === langCodes.en_CA ? (
    <>
      <Alert type="attention">
        To start earning commission on your dispensary sales, submit the
        {docsForCommissionsNeeded.length > 1 ? ' two documents' : ' document'} below!
      </Alert>

      {docsForCommissionsNeeded.reduce(
        (acc: React.ReactElement[], [key, { formTitle, formUrl }]) => {
          if (acc.length) {
            acc.push(<Spacer size={4} key={`${key}-spacer`} />)
          }
          acc.push(
            <StatusAndSubmitDoc
              formUrl={formUrl}
              isReceived={false}
              title={`${formTitle} Form`}
              key={key}
            />,
          )
          return acc
        },
        [],
      )}
    </>
  ) : docsForCommissionsNeeded.length > 1 ? (
    <MissingAccountInformationMessage />
  ) : null
}
